import React, { useEffect, useState } from 'react';
import Button from 'sushiweb/Button';
import Modal from 'sushiweb/Modal';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';

import {
  CreateButtonWrapper,
  FormWrapper,
  HearderInfoItem,
  HearderInfoWrapper,
  InputWrapper,
  OnlinePaymentsGap,
  StyledInput,
} from './styles';
import { formatDate } from '../../../../helpers';
import { applicableFlowTypes, currentFlowTypeEnum } from '../constants';
import { SingleLineArrow } from '../../../../components/SVGs/commonSVGs';

const PaymentUpdate = ({
  isVisible,
  closeModal,
  upsertPaymentSuccess,
  id,
  upsertPayment,
  upsertingPayment,
  heading,
  selectedWorkspace,
  currentFlow,
  getAllPayments,
}) => {
  const currentDate = formatDate(new Date());
  const [amountBalance, setAmount] = useState('');
  const [referenceID, setReferenceID] = useState('');
  const [paymentDate, setPaymentDate] = useState('');
  const workspaceID = selectedWorkspace.workspace_id ?? 'NA';
  const isInvoicePayment = currentFlow === currentFlowTypeEnum.FLOW_TYPE_LIMIT;
  const disabled = !(amountBalance && referenceID && paymentDate);

  useEffect(() => {
    if (upsertPaymentSuccess) {
      getAllPayments({
        workspaceId: selectedWorkspace.workspace_id,
        flowType: currentFlow,
      });
      closeModal();
    }
  }, [upsertPaymentSuccess]);

  const updateAmount = val => {
    if (val.length === 0) {
      setAmount('');
    }
    setAmount(val.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1'));
  };
  const getDateFromString = str => {
    const date = str.split(' ')[0];
    return date;
  };

  const updateReferenceID = val => {
    setReferenceID(val);
  };

  const handlePaymentDateChange = date => {
    setPaymentDate(date);
  };

  const upsert = () => {
    upsertPayment({
      amountBalance: Number.parseFloat(amountBalance),
      referenceID,
      id,
      workspaceID,
      paymentDate,
      currentFlow,
      isInvoicePayment,
    });
    setReferenceID('');
    setAmount('');
    setPaymentDate(paymentDate);
  };

  return (
    <Modal
      visible={isVisible}
      onClose={closeModal}
      showCloseIcon
      title={heading}
      isCentered
    >
      <HearderInfoWrapper>
        <HearderInfoItem>
          <OnlinePaymentsGap />
        </HearderInfoItem>
        <HearderInfoItem>
          &#x2022; Share the UTR after you have made a bank transfer to Zomato
        </HearderInfoItem>
        <HearderInfoItem>
          <HearderInfoItem.PlainText>
            &nbsp; using NEFT/RTGS/IMPS{' '}
          </HearderInfoItem.PlainText>
        </HearderInfoItem>
        <HearderInfoItem>
          &#x2022; Our team will verify the payment and approve/reject it within
          24 hours{' '}
        </HearderInfoItem>
        <HearderInfoItem>
          &#x2022; For immediate fund transfer, please use “Pay online” option{' '}
        </HearderInfoItem>
      </HearderInfoWrapper>
      <FormWrapper>
        <InputWrapper>
          <StyledInput
            fullWidth
            label='Amount transferred'
            value={amountBalance}
            onChange={updateAmount}
          />
        </InputWrapper>
        <InputWrapper>
          <StyledInput
            fullWidth
            label='UTR/Reference No.'
            value={referenceID}
            onChange={updateReferenceID}
          />
        </InputWrapper>
        <InputWrapper>
          <StyledInput
            label='Payment date'
            fullWidth
            type='date'
            value={getDateFromString(paymentDate)}
            max={currentDate}
            onChange={handlePaymentDateChange}
          />
        </InputWrapper>
      </FormWrapper>
      <CreateButtonWrapper>
        <Button
          onClick={upsert}
          loading={upsertingPayment}
          disabled={disabled}
          icon={<SingleLineArrow />}
          iconAlign='right'
        >
          Submit
        </Button>
      </CreateButtonWrapper>
    </Modal>
  );
};

PaymentUpdate.propTypes = {
  isVisible: PropTypes.bool,
  closeModal: PropTypes.func,
  upsertPayment: PropTypes.func,
  upsertingPayment: PropTypes.bool,
  upsertPaymentSuccess: PropTypes.bool,
  id: PropTypes.number,
  heading: PropTypes.string,
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
  getAllPayments: PropTypes.func,
};

PaymentUpdate.defaultProps = {
  isVisible: true,
  closeModal: _noop,
  upsertPayment: _noop,
  upsertPaymentSuccess: false,
  upsertingPayment: false,
  id: 0,
  heading: '',
  selectedWorkspace: {},
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
  getAllPayments: _noop,
};

export default PaymentUpdate;
